<template>
  <div class="pp-bg " id="pp-bg" >
    <transition name="fade">
        <Scanning   v-if="this.showSpinner"/>
        <div v-else-if="this.$store.state.limit < 0" class="d-flex h-100 flex-column justify-content-around align-items-center">
            <h2>Hai raggiunto il limite massimo dei controlli per oggi.</h2>
            <!-- <h4>Se vuoi eseguire altri controlli, puoi creare un Cybetower ID gratuitamente</h4>
            <button class="btn btn-primary btn-lg">Crea Cybetower<sup>&reg;</sup> ID</button> -->
        </div>
        <div v-else-if="!this.violazioni">
            <h1 class="mb-4 mt-3">SCOPRI SUBITO SE LA TUA PASSWORD <br> È STATA RUBATA</h1>
            <p class="mb-4">Inserisci qui sotto la tua e-mail per verificare se la tua password è stata rubata.</p>
            <h4 class="mb-2 text-left">Questo controllo ti permette di:</h4>
            <ul class="mb-2 check">
                <li><font-awesome-icon   icon="fa-solid fa-check" class="mr-2" /><span>Verificare subito se il tuo account è stato counvolto in violazioni</span></li>
                <li><font-awesome-icon   icon="fa-solid fa-check" class="mr-2" /><span>Verificare subito se i tuoi dati sono stati pubblicati sul Web, Deep Web, Dark Web</span></li>
                <li><font-awesome-icon   icon="fa-solid fa-check" class="mr-2" /><span>Scoprire subito se la tua password è stata rubata</span></li>
            </ul>
            <h4 class="mb-2 text-left">Questo controllo:</h4>
            <ul class="mb-2 cross">
                <li><font-awesome-icon   icon="fa-solid fa-xmark" class="mr-2" /><span><b>NON</b> richiede <b> NESSUNA </b> password</span></li>
                <li><font-awesome-icon   icon="fa-solid fa-xmark" class="mr-2"/><span><b>NON</b> richiede <b> NESSUN </b> dato personale</span></li>
            </ul>
            <h5 class="mb-4">
                Ci sono anche le tue tra le 
                <ContatoreViolazioni idd="contatore1" />
                informazioni rubate?
            </h5>
            <h4 class="mb-4">Scoprilo subito, basta inserire la tua e-mail:</h4>
            <p class="avvertenza mb-2">
                <font-awesome-icon   icon="fa-solid fa-triangle-exclamation" />
                Per favore <b>NON</b> inserire e-mail di altre persone senza autorizzazione 
                <font-awesome-icon   icon="fa-solid fa-triangle-exclamation" />
            </p>
            <CheckForm @controlForm="controllo" />
        </div>
        <div v-else-if="this.totale > 0 || this.phishing > 0">
            <h2>ATTENZIONE!</h2>
            <h3 class="">IL TUO ACCOUNT È STATO COINVOLTO IN 
                <span class="color-red">{{ parseInt(this.totale) + parseInt(this.phishing) }} </span> 
                <span v-if="(parseInt(this.totale) + parseInt(this.phishing)) > 1">&nbsp;VIOLAZIONI!</span>
                <span v-if="(parseInt(this.totale) + parseInt(this.phishing)) === 1">&nbsp;VIOLAZIONE!</span>
            </h3>
            <div class="card" v-for="violazioni in this.violazioni">
                <h5 class="card-header">{{ violazioni['Name'] }}</h5>
                <div class="card-body d-flex">
                    <div class="col-8">
                        <h5 class="card-title">Violazione subita il {{ this.monthTranslation(violazioni['BreachDate']) }}</h5>
                        <h5 class="card-title">Violazione segnalata il {{ this.monthTranslation(violazioni['AddedDate']) }}</h5>
                        <p class="dati-rubati">Dati rubati: </p>
                        <ul>
                            <li v-for="dato in this.wordTranslation(violazioni['DataClasses'])">
                                {{ dato }}
                            </li>
                        </ul>
                    </div>
                    <div class="col-4 d-flex justify-content-center align-items-center">
                        <Image :url="violazioni['LogoPath']" :alt="'logo'"/>
                    </div>
                </div>
            
            </div>
            <div class="card" v-if="this.phishing > 0">
                <h5 class="card-header">Vittima di Phishing</h5>
                <div class="card-body d-flex">
                    <div class="col-8">
                        <h5 class="card-title">Sei stato vittima {{ this.phishing }} {{ this.phishing === 1? "volta":"volte" }}</h5>
                        <p class="dati-rubati">Dati rubati: </p>
                        <ul>
                            <li>Email</li>
                            <li>Password ( in chiaro / leggibile )</li>
                        </ul>
                    </div>
                    <div class="col-4 d-flex justify-content-center align-items-center">
                        <img   src="@/assets/phishing.png" alt="">
                    </div>
                </div>
            
            </div>
            <button @click="reset" class="btn btn-outline-primary">Clicca per verificare un'altro TUO indirizzo!</button>
            <Consigli :violato="true" :landing="this.maillanding"/>
        </div>
        <div v-else>
            <h2 class="">Perfetto!</h2>
            <h3>Il tuo account al momento non risulta compromesso!</h3>
            <h3>Continua comunque a protegere le tue password!</h3>
            <button @click="reset" class="btn btn-outline-primary">Clicca per verificare un'altro TUO indirizzo!</button>
            <Consigli :violato="false" :landing="this.maillanding" :this="this.shownValuta" />
        </div>
    </transition>
</div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import hibpApi from '@/api/apis.js'
import dati from '@/assets/traduzioni/dati.json'
import mesi from '@/assets/traduzioni/mesi.json'
import { useRoute } from 'vue-router';
import '@/scripts/pixels.js'
import { mapActions, mapGetters } from 'vuex'

//import Counter from '@/scripts/counter.js'
import { ReCaptchaInstance } from 'recaptcha-v3';
import { setResult } from '@/store/actions'
export default {
    components:{
        CheckForm: defineAsyncComponent(() => import('@/components/Form.vue')),
        Scanning: defineAsyncComponent(() => import('@/components/Scanning.vue')),
        Consigli: defineAsyncComponent(() => import('@/components/Consigli.vue')),
        Image: defineAsyncComponent(() => import('@/components/Image.vue')),
        AttentionGrab: defineAsyncComponent(() => import('@/components/AttentionGrab.vue')),
        Arrow: defineAsyncComponent(() => import('@/components/Arrow.vue')),
        Countdown: defineAsyncComponent(() => import('@/components/Countdown.vue')),
        FlipClock: defineAsyncComponent(() => import('@/components/FlipClock.vue')),
        ContatoreViolazioni: defineAsyncComponent(() => import('@/components/ContatoreViolazioni.vue')),
    },
    data() {
        return {
            email: null,
            violazioni: null,
            phishing: null,
            showResult: false,
            datiTradotti: JSON.parse(JSON.stringify(dati)),
            mesi: JSON.parse(JSON.stringify(mesi)),
            totale: null,
            mese: null,
            dati: null,
            showSpinner: false,
            phishing: 0,
            phishingData: null,
            contatore: null,
            clientIp: null,
            maillanding:false,
            valuta: null,
            shownValuta: "EUR",
            messageError: null,
        }
    },
    methods: {
        ...mapActions(['updateEmail', 'updateLimit', 'init', 'setResult']),
        Counter() {
            let startNumber = Date.now() /100 - 2200000000
            window.localStorage.setItem("start", startNumber)
            
            let text = parseInt((startNumber)).toLocaleString(undefined, { minimumFractionDigits: 0 })
            this.contatore = text
            
            const z = setInterval(() => {
                try {
                    let startNumber = Date.now() /100 - 2200000000
                    startNumber = parseInt(startNumber) + Math.floor(Math.random() * 12)
                    let text = parseInt((startNumber)).toLocaleString(undefined, { minimumFractionDigits: 0 })
                    this.contatore = text;

                    window.localStorage.setItem('start', parseInt(startNumber))
                }catch (error) {
                    
                }
            }, 1600)
        },
        async recaptchaCheck() {
            return true
        },
        async controllo ( email, token ) {
            console.log(token)
            this.setResult()
            const $captcha = await this.recaptchaCheck()
            if($captcha){
                this.showSpinner = true
                if(typeof fbq !== undefined){
                    fbq('track', 'SubmitApplication')
                }else {
                    fbq('init', '3906996172648868')
                    fbq('track', 'SubmitApplication')
                }
                this.updateEmail(email)
                if (this.$store.state.limit === 0) {
                    this.showSpinner = false
                    return null
                }
                await hibpApi.post('/test.php',null,{ params: { email } })
                    .then(res => {
                        this.totale = 0;
                        this.email = email
                        this.updateLimit()
                        try {
                            
                            this.violazioni = JSON.parse(Object.values(res)[0])
                            this.totale = this.violazioni.length > 0 ? this.violazioni.length:0
                            
                            if(this.totale > 0){
                                this.mese = this.monthTranslation(JSON.parse(Object.values(res)[0])[0]['BreachDate'])
                                this.dati = this.wordTranslation(JSON.parse(Object.values(res)[0])[0]['DataClasses'])
                            }
                        }catch (error) {
                            this.violazioni = true
                            return false;
                        }
                    })
                    const now = new Date()
                    const time = `${now.getHours()}:${now.getMinutes()}`
                    if(!this.clientIp){
                        await this.getIp()
                    }
                    await hibpApi.post('/phishing.php', null, { params: { email, ip: this.clientIp, time, total: this.totale } })
                    .then( res => {
                        let arr = res.data
                        this.phishing = parseInt(arr[1].times)
                    } )
                    let times = parseInt(this.totale) + parseInt(this.phishing)
                    await hibpApi.post('/ac.php', null, { params: { email, times } })
                        .then( res => { return true } )
                    this.showSpinner = false
                    this.setResult()
                }
        },
        reset() {
            this.email = null
            this.violazioni = null
            this.phishing = null
            this.showResult = false
            this.datiTradotti = JSON.parse(JSON.stringify(dati))
            this.mesi = JSON.parse(JSON.stringify(mesi))
            this.totale = null
            this.mese = null
            this.dati = null
            this.showSpinner = false
            this.phishing = 0
            this.phishingData = null
            this.contatore = null
            this.clientIp = null
            this.maillanding =false
            this.valuta = null
            this.shownValuta = "EUR"
            this.messageError = null
            this.$router.push({name: 'home'})
            document.querySelector('.pp-bg').className = 'pp-bg'
        },
        monthTranslation( month ) {
            let date = new Date(month);
            let str_date = date.toLocaleDateString('ch-IT')
            date = str_date.split('/')

            if(month){
                let index = date[1] > 9 ? date[1]: `0${date[1]}`
                const mese = this.mesi[index]

                return `${date[0]} ${mese} ${date[2]}`
            }
        },
        wordTranslation( word ) {
            const arr = []

            word.forEach(dato => {
                arr.push(this.datiTradotti[dato])
            });
            return arr
        },
        async getIp(){
            fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then(response => {
                this.clientIp = response.ip;
            });
        }
    },
    watch: {
        totale(value) {
            try {
                if(value > 0){
                    const el = document.getElementById('pp-bg')
                    el.classList.remove('green')
                    el.classList.add('red')
                }else if (value === 0) {
                    const el = document.getElementById('pp-bg')
                    if (this.email) el.classList.add('green')
                }
            }catch (error) {
                return false
            }
        }, 
        contatore(newvalue,oldvalue){
            try {
                if(oldvalue < newvalue){
                    const counterElm = document.getElementById('counter')
                    counterElm.classList.add('blink')
                    setTimeout(() => {
                        counterElm.classList.remove('blink')
                    }, 500)
                }
            }catch(error) {
                return false
            }
        },
        phishing(newvalue,oldvalue){
            let totale = this.totale + newvalue
            try {
                if(totale > 0){
                    const el = document.getElementById('pp-bg')
                    el.classList.remove('green')
                    el.classList.add('red')
                }else {
                    const el = document.getElementById('pp-bg')
                    el.classList.add('green')
                }
            }catch (error) {
                return false
            }
        }
    },
    mounted() {
        
        this.init()
        this.Counter() 
        this.getIp()
        let route = useRoute()
        if (typeof route.query.e != 'undefined'){
            this.controllo(decodeURI(route.query.e))
            this.maillanding = true
        }
        if(typeof route.query.s != 'undefined'){
            this.valuta = String(route.query.s)
        }
        if (typeof route.query.m != 'undefined'){
            this.messageError = 'Limite giornaliero superato! riprova domani!'
        }
        switch(this.valuta){
            case "cnpUVm1HSE1wbHB6TlpkZHRBRmh2QT09":
                this.shownValuta = "EUR"
                break
            case "VnFSazc0ZmZVZXNJaEZkT2lLZUt5dz09":
                this.p1= "7",
                this.p2 =  "27",
                this.p2old =  "84",
                this.p3 =  "297",
                this.p3old =  "6720"
                this.shownValuta = "CHF"
                break
            case "dlJselBOVDAwbURwQXhudm4vWDJMdz09":
                this.shownValuta = "USD"
                break
            case "UG96VmR1V280d1czcXd3MWxQZHg5dz09":
                this.shownValuta = "GBP"
                break
        }

    }

}
</script>

<style scoped>
    .pp-bg {
        padding: 25px 50px;
        background: rgba(0, 0, 0, 0.6);
        color: white;
        margin-right: 3rem;
        width: 80%;
        min-height: 76%;
        z-index: 1;
    }

    @media  screen and (max-width: 767px) {
        .pp-bg {
            width: 100%;
            margin:0;
        }
    }
    .pp-bg.green {
        background:rgba(00,80,37,.6)
    }
    .dati-rubati, .card-title {
        text-align: left;
        padding-left: 80px; 
    }
    .card {
        color: #333;
    }   
    .avvertenza {
        color: #ffd700;
    }
    .text-left{
        padding-left: 15% ;
        text-align: left;
    }
    ul.cross, ul.check{
        background: transparent;
        list-style: none;
    }
    .mr-2 {
        margin-right: 10px;
    }
    .check .mr-2 {
        color: #66ff00;
        font-size: 20px;
    }
    .cross .mr-2{
        color: red;
        font-size: 25px;
    }
    .color-blue {
        color: #1574ea;
        
        font-weight: 800;
    }
    img {
        max-width: 100%;
        max-height: 100px;
    }
    .color-red {
        color: red;
        font-weight: 800;
    }
    ul {
       width: 60%;
       margin: 0 auto;
       text-align: left;
    }
    .cross li, .check li {
        display: flex;
        justify-content: flex-start;
        align-items: start;
        font-size: 18px;
    }
    .pp-bg.red .card {
        background: rgba(255, 50, 50, 0.6);
        color: white;
        margin-bottom: 20px;
    }
    .blink {
        transition: all 200ms ease;
        animation: blink 300ms linear;
    }
    @keyframes blink {
        50% {
            opacity: .5;
        }
    }


    .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>